﻿// Shrine Theme - Working Cracked Version
// All obfuscated license code removed

const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};

let subscribers = {};

function subscribe(event, callback) {
  if (!subscribers[event]) subscribers[event] = [];
  subscribers[event].push(callback);
  return function () {
    subscribers[event] = subscribers[event].filter(cb => cb !== callback);
  };
}

function publish(event, data = {}) {
  if (subscribers[event]) {
    subscribers[event].forEach(callback => callback(data));
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function trapFocus(container, elementToFocus) {
  if (elementToFocus) elementToFocus.focus();
}

function removeTrapFocus(element) {
  if (element) element.focus();
}

// CART REMOVE BUTTON
if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        e.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        if (cartItems) cartItems.updateQuantity(this.dataset.index, 0);
      });
    }
  });
}

// CART ITEMS
if (!customElements.get('cart-items')) {
  customElements.define('cart-items', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', debounce((e) => {
        this.updateQuantity(e.target.dataset.index, e.target.value);
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }

    updateQuantity(line, quantity) {
      fetch(window.routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          line,
          quantity,
          sections: 'main-cart-items,cart-icon-bubble,main-cart-footer',
          sections_url: window.location.pathname
        })
      })
        .then(res => res.json())
        .then(state => {
          if (state.sections && state.sections['main-cart-items']) {
            const html = new DOMParser().parseFromString(state.sections['main-cart-items'], 'text/html');
            const newItems = html.querySelector('.js-contents');
            const current = document.querySelector('#main-cart-items .js-contents');
            if (newItems && current) current.innerHTML = newItems.innerHTML;
          }

          if (state.sections && state.sections['cart-icon-bubble']) {
            const html = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
            const icon = document.getElementById('cart-icon-bubble');
            if (icon && html.body.firstChild) icon.innerHTML = html.body.firstChild.innerHTML;
          }

          if (state.sections && state.sections['main-cart-footer']) {
            const html = new DOMParser().parseFromString(state.sections['main-cart-footer'], 'text/html');
            const newFooter = html.querySelector('.js-contents');
            const current = document.querySelector('#main-cart-footer .js-contents');
            if (newFooter && current) current.innerHTML = newFooter.innerHTML;
          }
        });
    }
  });
}

// CART DRAWER ITEMS
if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', debounce((e) => {
        this.updateQuantity(e.target.dataset.index, e.target.value);
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }

    updateQuantity(line, quantity) {
      fetch(window.routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          line: parseInt(line),
          quantity: parseInt(quantity),
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(res => res.ok ? res.json() : res.json().then(err => { throw err; }))
        .then(state => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.renderContents) {
            cartDrawer.renderContents(state);
          }
        })
        .catch(err => {/* Cart update error */ });
    }
  });
}

// CART DRAWER
if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());

      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', () => this.close());

      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      }
    }

    open() {
      this.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }

    renderContents(state) {
      if (state.sections && state.sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
        const newDrawerInner = html.querySelector('.drawer__inner');
        const currentDrawerInner = this.querySelector('.drawer__inner');

        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        }

        const itemCount = state.item_count || (state.items ? state.items.length : 0);
        if (itemCount === 0) {
          this.classList.add('is-empty');
        } else {
          this.classList.remove('is-empty');
        }
      }

      if (state.sections && state.sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
        const icon = document.getElementById('cart-icon-bubble');
        if (icon && html.body.firstChild) {
          icon.innerHTML = html.body.firstChild.innerHTML;
        }
      }

      this.open();
    }
  });
}

// PRODUCT FORM
if (!customElements.get('product-form')) {
  customElements.define('product-form', class extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const formData = new FormData(this.form);
        let variantId = formData.get('id');

        if (!variantId || variantId === 'null' || variantId === '') {
          const idInput = this.form.querySelector('input[name="id"]:checked') ||
            this.form.querySelector('input[name="id"]');
          if (idInput) variantId = idInput.value;
        }

        if (!variantId || variantId === 'null' || variantId === '') {
          const variantSelector = this.querySelector('variant-selects, variant-radios');
          if (variantSelector && variantSelector.currentVariant) {
            variantId = variantSelector.currentVariant.id;
          }
        }

        if (!variantId || variantId === 'null' || variantId === '') {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          alert('Lütfen bir varyant seçin');
          return;
        }

        const items = [];

        // Check if quantity breaks is active
        const quantityBreaks = this.form.querySelector('quantity-breaks');
        const activeQuantityRadio = quantityBreaks ? quantityBreaks.querySelector('input[name="quantity"]:checked') : null;
        const activeLabel = activeQuantityRadio ? quantityBreaks.querySelector(`label[data-input="${activeQuantityRadio.dataset.input}"]`) : null;

        if (activeLabel && activeLabel.querySelector('.quantity-break__selector-item')) {
          // Quantity breaks mode - add each variant separately
          const selectorItems = activeLabel.querySelectorAll('.quantity-break__selector-item');

          console.log('🔍 DEBUG: Found selector items:', selectorItems.length);

          // Get variant data from variant-selects
          const variantSelects = document.querySelector('variant-selects');
          const variantScript = variantSelects ? variantSelects.querySelector('script[type="application/json"]') : null;
          const allVariants = variantScript ? JSON.parse(variantScript.textContent) : [];

          console.log('🔍 DEBUG: Total variants available:', allVariants.length);

          selectorItems.forEach((item, index) => {
            // Read current selected values from dropdowns
            const selects = item.querySelectorAll('select');
            const selectedOptions = Array.from(selects).map(s => s.value);

            console.log(`🔍 DEBUG: Item #${index + 1} - Selected options:`, selectedOptions);

            // Find matching variant
            const matchedVariant = allVariants.find(v => {
              return !v.options.map((opt, i) => selectedOptions[i] === opt).includes(false);
            });

            console.log(`🔍 DEBUG: Item #${index + 1} - Matched variant:`, matchedVariant ? matchedVariant.id : 'NOT FOUND');

            if (matchedVariant && matchedVariant.id) {
              items.push({ id: String(matchedVariant.id), quantity: 1 });
            }
          });

          console.log('🔍 DEBUG: Final items array:', items);

          // If no variants were collected, fallback to single item
          if (items.length === 0) {
            items.push({
              id: String(variantId),
              quantity: parseInt(activeQuantityRadio?.value || formData.get('quantity') || 1)
            });
          }
        } else {
          // Normal mode - single variant
          items.push({
            id: String(variantId),
            quantity: parseInt(formData.get('quantity') || 1)
          });
        }

        // Add selected upsells
        document.querySelectorAll('[data-selected="true"]').forEach(upsell => {
          const upsellId = String(upsell.dataset.id);
          if (upsellId && !items.find(item => item.id === upsellId)) {
            items.push({ id: upsellId, quantity: 1 });
          }
        });

        const body = { items };
        if (this.cart) {
          body.sections = ['cart-drawer', 'cart-icon-bubble'];
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(res => res.json())
          .then(state => {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');

            if (state.status || state.message || state.description) {
              alert(state.description || state.message || 'Hata oluştu');
              return;
            }

            if (this.cart && this.cart.renderContents) {
              this.cart.renderContents(state);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch(err => {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            alert('Sepete eklenirken hata oluştu');
          });
      });
    }
  });
}

// VARIANT SELECTS
if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', () => {
        this.updateOptions();
        this.updateMasterId();
        if (this.currentVariant) {
          this.updateVariantInput();
          this.updateURL();
        }
      });
      this.updateOptions();
      this.updateMasterId();
      if (this.currentVariant) this.updateVariantInput();
    }

    updateOptions() {
      // Hem select hem de radio/checkbox inputları kontrol et
      const inputs = this.querySelectorAll('.product-form__input');
      this.options = Array.from(inputs).map(input => {
        // Select dropdown kontrolü
        const select = input.querySelector('select');
        if (select) return select.value;

        // Radio button kontrolü (pills, swatches, quantity breaks)
        const checked = input.querySelector('input[type="radio"]:checked');
        if (checked) return checked.value;

        // Checkbox kontrolü
        const checkbox = input.querySelector('input[type="checkbox"]:checked');
        if (checkbox) return checkbox.value;

        return null;
      }).filter(Boolean);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find(v => {
        return !v.options.map((opt, i) => this.options[i] === opt).includes(false);
      });
    }

    updateVariantInput() {
      const productForm = this.closest('product-form') || document.querySelector('product-form');
      if (productForm) {
        const form = productForm.querySelector('form');
        let input = form?.querySelector('input[name="id"]');

        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'id';
          form?.appendChild(input);
        }

        if (input && this.currentVariant) {
          input.value = this.currentVariant.id;
          input.disabled = false;
        }
      }
    }

    updateURL() {
      if (this.currentVariant && this.dataset.updateUrl !== 'false') {
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      }
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  });
}

// VARIANT RADIOS
if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', () => {
        this.updateOptions();
        this.updateMasterId();
        if (this.currentVariant) {
          this.updateVariantInput();
          this.updateURL();
        }
      });
      this.updateOptions();
      this.updateMasterId();
      if (this.currentVariant) this.updateVariantInput();
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('fieldset')).map(fieldset => {
        return Array.from(fieldset.querySelectorAll('input')).find(r => r.checked)?.value;
      }).filter(Boolean);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find(v => {
        return !v.options.map((opt, i) => this.options[i] === opt).includes(false);
      });
    }

    updateVariantInput() {
      const productForm = this.closest('product-form') || document.querySelector('product-form');
      if (productForm) {
        const form = productForm.querySelector('form');
        let input = form?.querySelector('input[name="id"]');

        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'id';
          form?.appendChild(input);
        }

        if (input && this.currentVariant) {
          input.value = this.currentVariant.id;
          input.disabled = false;
        }
      }
    }

    updateURL() {
      if (this.currentVariant && this.dataset.updateUrl !== 'false') {
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      }
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  });
}

// QUANTITY INPUT
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const prev = this.input.value;
          e.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
          if (prev !== this.input.value) {
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }
  });
}

// PRODUCT UPSELL (empty definition - just to make the element work in DOM)
if (!customElements.get('product-upsell')) {
  customElements.define('product-upsell', class extends HTMLElement {
    constructor() {
      super();
    }
  });
}

// CART DRAWER UPSELL (empty definition - just to make the element work in DOM)
if (!customElements.get('cart-drawer-upsell')) {
  customElements.define('cart-drawer-upsell', class extends HTMLElement {
    constructor() {
      super();
    }
  });
}

// COMPARISON SLIDER (empty definition)
if (!customElements.get('comparison-slider')) {
  customElements.define('comparison-slider', class extends HTMLElement {
    constructor() {
      super();
    }
  });
}

// UPSELL TOGGLE - Simple approach without custom elements
document.addEventListener('click', (e) => {
  // Find any toggle button in the click path
  const toggleBtn = e.target.closest('.upsell__toggle-switch') ||
    e.target.closest('.upsell__checkbox') ||
    e.target.closest('.upsell__plus-btn') ||
    e.target.closest('.upsell-toggle-btn') ||
    (e.target.closest('.upsell__container') && e.target.closest('.upsell__container').classList.contains('upsell-toggle-btn'));

  if (toggleBtn) {
    // Find parent with class containing 'upsell'
    let parent = toggleBtn.parentElement;
    while (parent && !parent.hasAttribute('data-toggle')) {
      parent = parent.parentElement;
    }

    if (parent && parent.getAttribute('data-toggle') === 'true') {
      e.preventDefault();
      e.stopPropagation();

      const currentState = parent.getAttribute('data-selected');
      const newState = currentState === 'true' ? 'false' : 'true';
      parent.setAttribute('data-selected', newState);
    }
  }
});

// COMPARISON SLIDER - Initialize after DOM loads
setTimeout(() => {
  const sliders = document.querySelectorAll('comparison-slider');

  sliders.forEach(slider => {
    const overlay = slider.querySelector('.comparison-slider__overlay');
    const line = slider.querySelector('.comparison-slider__line');
    const input = slider.querySelector('.comparison-slider__input');

    if (!overlay || !line || !input) {
      return;
    }

    let isDragging = false;

    const updatePosition = (value) => {
      overlay.style.width = value + '%';
      line.style.left = value + '%';
      input.value = value;
    };

    // Range input change
    input.addEventListener('input', (e) => {
      updatePosition(e.target.value);
    });

    // Mouse drag on line/handle
    line.addEventListener('mousedown', (e) => {
      isDragging = true;
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const rect = slider.getBoundingClientRect();
      let position = ((e.clientX - rect.left) / rect.width) * 100;
      position = Math.max(0, Math.min(100, position));
      updatePosition(position);
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
    });

    // Touch drag
    line.addEventListener('touchstart', (e) => {
      isDragging = true;
      e.preventDefault();
    });

    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const rect = slider.getBoundingClientRect();
      let position = ((e.touches[0].clientX - rect.left) / rect.width) * 100;
      position = Math.max(0, Math.min(100, position));
      updatePosition(position);
    });

    document.addEventListener('touchend', () => {
      isDragging = false;
    });

    // Click anywhere on slider
    slider.addEventListener('click', (e) => {
      if (e.target === line || e.target.closest('.comparison-slider__line')) return;
      const rect = slider.getBoundingClientRect();
      let position = ((e.clientX - rect.left) / rect.width) * 100;
      position = Math.max(0, Math.min(100, position));
      updatePosition(position);
    });
  });
}, 1000);

// QUANTITY BREAKS - Variant selector handler
if (!customElements.get('quantity-breaks')) {
  customElements.define('quantity-breaks', class extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Quantity break radio'ları dinle
      const quantityRadios = this.querySelectorAll('input[name="quantity"]');
      quantityRadios.forEach(radio => {
        radio.addEventListener('change', () => this.updateVariantSelectors());
      });

      // İçerideki tüm variant dropdown'ları dinle
      const variantSelects = this.querySelectorAll('.quantity-break__selector-item select');
      variantSelects.forEach(select => {
        select.addEventListener('change', (e) => this.handleVariantChange(e));
      });

      // İlk yüklemede de güncelle
      this.updateVariantSelectors();
    }

    getVariantData() {
      // Variant data'yı al - birkaç yerden dene

      // 1. Quantity-breaks içinde varsa
      let variantScript = this.querySelector('script[type="application/json"]');

      // 2. Yoksa variant-selects'te ara
      if (!variantScript) {
        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects) {
          variantScript = variantSelects.querySelector('script[type="application/json"]');
        }
      }

      // 3. Hala yoksa product-info içinde ara
      if (!variantScript) {
        const productInfo = document.querySelector('product-info');
        if (productInfo) {
          variantScript = productInfo.querySelector('script[type="application/json"]');
        }
      }

      // 4. Son çare: sayfada variant data'yı bul
      if (!variantScript) {
        variantScript = document.querySelector('[data-product-variants] script[type="application/json"]');
      }

      if (!variantScript) {
        console.error('Quantity Breaks: Variant data bulunamadı');
        return null;
      }

      try {
        return JSON.parse(variantScript.textContent);
      } catch (error) {
        console.error('Quantity Breaks: JSON parse error', error);
        return null;
      }
    }

    handleVariantChange(e) {
      const selectorItem = e.target.closest('.quantity-break__selector-item');
      if (!selectorItem) return;

      // Seçilen varyantı bul
      const selectedOptions = Array.from(
        selectorItem.querySelectorAll('select')
      ).map(s => s.value);

      // Variant data'yı al
      const variants = this.getVariantData();
      if (!variants) return;

      const matchedVariant = variants.find(v => {
        return !v.options.map((opt, i) => selectedOptions[i] === opt).includes(false);
      });

      if (matchedVariant) {
        // Selector item'ı güncelle
        selectorItem.setAttribute('data-selected-id', matchedVariant.id);

        // Eğer bu aktif olan quantity break'in ilk item'ıysa, ana variant input'u güncelle
        const activeRadio = this.querySelector('input[name="quantity"]:checked');
        if (activeRadio) {
          const activeLabel = this.querySelector(`label[data-input="${activeRadio.dataset.input}"]`);
          if (activeLabel) {
            const firstSelector = activeLabel.querySelector('.quantity-break__selector-item');
            // Eğer değiştirilen item, aktif break'in ilk item'ıysa
            if (firstSelector === selectorItem) {
              this.updateMainVariantInput(matchedVariant.id);
            }
          }
        }
      }
    }

    updateVariantSelectors() {
      // Aktif quantity break'i bul
      const activeRadio = this.querySelector('input[name="quantity"]:checked');
      if (!activeRadio) return;

      const activeLabel = this.querySelector(`label[data-input="${activeRadio.dataset.input}"]`);
      if (!activeLabel) return;

      // Bu label içindeki ilk variant selector'ı bul ve variant'ını kullan
      const firstSelector = activeLabel.querySelector('.quantity-break__selector-item');
      if (firstSelector) {
        const selectedId = firstSelector.getAttribute('data-selected-id');
        if (selectedId) {
          this.updateMainVariantInput(selectedId);
        } else {
          // Eğer data-selected-id yoksa, dropdown'lardan hesapla
          const selectedOptions = Array.from(
            firstSelector.querySelectorAll('select')
          ).map(s => s.value);

          const variants = this.getVariantData();
          if (variants) {
            const matchedVariant = variants.find(v => {
              return !v.options.map((opt, i) => selectedOptions[i] === opt).includes(false);
            });

            if (matchedVariant) {
              firstSelector.setAttribute('data-selected-id', matchedVariant.id);
              this.updateMainVariantInput(matchedVariant.id);
            }
          }
        }
      }
    }

    updateMainVariantInput(variantId) {
      const productForm = document.querySelector('product-form');
      if (!productForm) return;

      const form = productForm.querySelector('form');
      if (!form) return;

      let input = form.querySelector('input[name="id"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        form.appendChild(input);
      }

      input.value = variantId;
      input.disabled = false;

      // URL'yi de güncelle
      const product = document.querySelector('[data-product-url]');
      const productUrl = product?.getAttribute('data-product-url');
      if (productUrl) {
        window.history.replaceState({}, '', `${productUrl}?variant=${variantId}`);
      }
    }
  });
}


// BUNDLE DEALS - Variant selector handler
if (!customElements.get('bundle-deals')) {
  customElements.define('bundle-deals', class extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Tüm variant dropdown'ları dinle
      const variantSelects = this.querySelectorAll('.bundle-deals__variant-selects-js select');
      variantSelects.forEach(select => {
        select.addEventListener('change', (e) => this.handleVariantChange(e));
      });
    }

    handleVariantChange(e) {
      const variantPickerContainer = e.target.closest('.bundle-deals__variant-selects-js');
      if (!variantPickerContainer) return;

      const itemIndex = variantPickerContainer.dataset.index;

      // Seçilen varyantları topla
      const selectedOptions = Array.from(
        variantPickerContainer.querySelectorAll('select')
      ).map(s => s.value);

      // Variant data'yı al - JSON script'ten oku
      const variantScript = variantPickerContainer.querySelector('script[type="application/json"]');
      if (!variantScript) return;

      try {
        const variants = JSON.parse(variantScript.textContent);
        const matchedVariant = variants.find(v => {
          return !v.options.map((opt, i) => selectedOptions[i] === opt).includes(false);
        });

        if (matchedVariant) {
          // Checkbox'ı bul - container içinde data-index ile ara
          const productContainer = variantPickerContainer.closest('.upsell__container');
          const checkbox = productContainer ? productContainer.querySelector('.bundle-deals__checkbox-js') : null;

          if (checkbox) {
            checkbox.dataset.id = matchedVariant.id;
            checkbox.setAttribute('data-id', matchedVariant.id);
          }

          // Parent upsell container'ı bul ve data-id'yi güncelle
          const upsellContainer = variantPickerContainer.closest('[data-id]');
          if (upsellContainer) {
            upsellContainer.dataset.id = matchedVariant.id;
            upsellContainer.setAttribute('data-id', matchedVariant.id);
          }

          // Varyant resmini güncelle
          this.updateVariantImage(matchedVariant, productContainer);

          // Fiyatları güncelle (eğer enable_price_changes true ise)
          if (this.dataset.updatePrices === 'true') {
            this.updatePrices(matchedVariant, checkbox, productContainer);
          }
        }
      } catch (error) {
        console.error('Bundle variant change error:', error);
      }
    }

    updateVariantImage(variant, container) {
      if (!container) return;

      const mediaImg = container.querySelector('.bundle-deals__media-item-img-js');
      if (!mediaImg) return;

      // Shopify variant image handling
      if (variant.featured_media && variant.featured_media.preview_image) {
        // Yeni Shopify API format
        const imageUrl = variant.featured_media.preview_image.src;
        if (imageUrl) {
          mediaImg.src = imageUrl;
          if (variant.featured_media.preview_image.alt) {
            mediaImg.alt = variant.featured_media.preview_image.alt;
          }
        }
      } else if (variant.featured_image) {
        // Eski format - featured_image direkt object
        const imageUrl = variant.featured_image.src || variant.featured_image;
        if (imageUrl) {
          mediaImg.src = imageUrl;
        }
      }
    }

    updatePrices(variant, checkbox, container) {
      const percentageLeft = parseFloat(this.dataset.percentageLeft || '1');
      const fixedDiscount = parseFloat(this.dataset.fixedDiscount || '0');

      // NaN kontrolü
      if (isNaN(percentageLeft) || isNaN(fixedDiscount)) {
        console.error('Invalid discount values');
        return;
      }

      // Yeni fiyat hesapla
      const newPrice = (variant.price * percentageLeft) - fixedDiscount;
      const comparePrice = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;

      // Checkbox data-price'ı güncelle
      if (checkbox) {
        checkbox.dataset.price = newPrice;
        checkbox.dataset.comparePrice = comparePrice;
      }

      // Container içindeki fiyat span'larını bul ve güncelle
      if (container) {
        const priceElement = container.querySelector('.bundle-deals__price-js');
        const comparePriceElement = container.querySelector('.bundle-deals__compare-price-js');

        if (priceElement) {
          // Shopify money formatını kullan
          if (window.Shopify && window.Shopify.formatMoney) {
            priceElement.textContent = window.Shopify.formatMoney(newPrice, window.theme.moneyFormat || '${{amount}}');
          } else {
            priceElement.textContent = this.formatMoney(newPrice);
          }
        }

        if (comparePriceElement) {
          if (comparePrice > newPrice) {
            if (window.Shopify && window.Shopify.formatMoney) {
              comparePriceElement.textContent = window.Shopify.formatMoney(comparePrice, window.theme.moneyFormat || '${{amount}}');
            } else {
              comparePriceElement.textContent = this.formatMoney(comparePrice);
            }
            comparePriceElement.style.display = '';
          } else {
            comparePriceElement.textContent = '';
            comparePriceElement.style.display = 'none';
          }
        }
      }

      // Toplam fiyatları yeniden hesapla
      this.updateTotalPrices();
    }

    updateTotalPrices() {
      let totalPrice = 0;
      let totalComparePrice = 0;

      // Sadece checked olan checkbox'ları topla
      const checkedBoxes = this.querySelectorAll('.bundle-deals__checkbox-js:checked');
      checkedBoxes.forEach(checkbox => {
        const price = parseFloat(checkbox.dataset.price || '0');
        const comparePrice = parseFloat(checkbox.dataset.comparePrice || '0');

        // NaN kontrolü
        if (!isNaN(price)) totalPrice += price;
        if (!isNaN(comparePrice)) totalComparePrice += comparePrice;
      });

      // Toplam fiyat elementlerini güncelle
      const totalPriceEl = this.querySelector('.bundle-deals__total-price-js');
      const totalComparePriceEl = this.querySelector('.bundle-deals__total-compare-price-js');

      if (totalPriceEl) {
        if (window.Shopify && window.Shopify.formatMoney) {
          totalPriceEl.textContent = window.Shopify.formatMoney(totalPrice, window.theme.moneyFormat || '${{amount}}');
        } else {
          totalPriceEl.textContent = this.formatMoney(totalPrice);
        }
      }

      if (totalComparePriceEl) {
        if (totalComparePrice > totalPrice) {
          if (window.Shopify && window.Shopify.formatMoney) {
            totalComparePriceEl.textContent = window.Shopify.formatMoney(totalComparePrice, window.theme.moneyFormat || '${{amount}}');
          } else {
            totalComparePriceEl.textContent = this.formatMoney(totalComparePrice);
          }
          totalComparePriceEl.style.display = '';
        } else {
          totalComparePriceEl.textContent = '';
          totalComparePriceEl.style.display = 'none';
        }
      }
    }

    formatMoney(cents) {
      // Fallback para formatı - Shopify yüklenememişse
      if (isNaN(cents)) return '$0.00';

      const amount = (cents / 100).toFixed(2);
      const currencySymbol = this.dataset.currencySymbol || '$';
      return `${currencySymbol}${amount}`;
    }
  });
}
